import moment from 'moment';

// Accepted date formats so that moment doesn't interpret "08 10" as 10th Aug
const formats = [
  'D',
  'DD',
  'D M',
  'DDMM',
  'DDM',
  'DDMMM',
  'DD MM',
  'DD MMM',
  'DD/MM',
  'DD-MM',
  'DD MM YY',
  'DD MMM YY',
  'DD/MM/YY',
  'DD-MM-YY',
  'DD MM YYYY',
  'DD MMM YYYY',
  'DD/MM/YYYY',
  'DD-MM-YYYY'
];

/**
 * @param {string} value - text input
 * */
export const predictDate = (value) => {
  let dateObj = moment(value, formats);
  const today = moment();

  if (parseInt(value, 10) && !dateObj.isValid()) {
    dateObj = moment().set({
      year: today.year(),
      month: today.add(1, 'month').month(),
      date: value
    });
  }

  if (dateObj.isBefore(today, 'day')) {
    dateObj = moment(value, formats).set({
      year: today.year()
    });
  }

  if (dateObj.isBefore(today, 'day')) {
    const isFormatDayOnly = /^\W*\d{1,2}\W*$/.test(value);
    dateObj.add(1, isFormatDayOnly ? 'month' : 'year');
  }

  return dateObj;
};
